import { useCallback } from 'react'
import { Trans, useLingui } from '@lingui/react/macro'

import * as Form from '@/features/form'
import Checkbox from '@/components/ui/Checkbox'
import { useClaimOrganization } from '../hooks/useClaimOrganization'

type FormData = {
  slug: string
  secret: string
  acceptedContract: boolean
}

interface Props {
  secret: string
  slug: string
}

export default function ClaimOrganization({ slug, secret }: Props) {
  const { t } = useLingui()
  const { claim, errors } = useClaimOrganization()

  const submit = useCallback(
    async (data: FormData) => {
      await claim(data)
    },
    [claim]
  )

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-heading1">
        <Trans>Claim your Guest-App</Trans>
      </h1>
      <h2 className="text-heading3 md:text-heading2 text-text">
        <strong>
          <Trans>Subdomain</Trans>
        </strong>
        : &quot;{slug}&quot;
      </h2>
      <Form.Root<FormData>
        onSubmit={submit}
        serverErrors={errors}
        defaultValues={{
          slug,
          secret,
          acceptedContract: false
        }}
      >
        <div className="flex w-full flex-col gap-6 items-stretch">
          <div hidden>
            <Form.Field
              name="slug"
              rules={{
                required: t`This field is required`
              }}
            >
              {({ renderProps: { value, name } }) => (
                <input hidden type="text" value={value} name={name} readOnly />
              )}
            </Form.Field>
          </div>
          <div hidden>
            <Form.Field
              name="secret"
              rules={{
                required: t`This field is required`
              }}
            >
              {({ renderProps: { value, name } }) => (
                <input hidden type="text" value={value} name={name} readOnly />
              )}
            </Form.Field>
          </div>
          <Form.Field
            name="acceptedContract"
            rules={{ required: t`This field is required` }}
          >
            {({ renderProps: { onChange, value, ...props } }) => (
              <Checkbox
                checked={value}
                onChange={() => onChange(!value)}
                {...props}
              >
                <div className="inline">
                  <Trans>
                    I agree to GuestGoodies{' '}
                    <a
                      className="text-secondary underline"
                      href="/saas"
                      target="_blank"
                    >
                      SaaS Contract and Data Processing Agreement
                    </a>
                    .
                  </Trans>
                </div>
              </Checkbox>
            )}
          </Form.Field>
          <Form.Error name="root.serverError" />
          <div className="flex flex-row justify-end">
            <Form.Submit>
              <Trans>Claim</Trans>
            </Form.Submit>
          </div>
        </div>
      </Form.Root>
    </div>
  )
}
